export default __webpack_public_path__ + "static/links-dream-01-b168b81cd36d0d962f58ab9f8ffd05e4.png";